import { Component, Host, h, Prop, State, Build } from '@stencil/core';

const SCRIV = 'https://swishify.ai';

@Component({
  tag: 'swish-chat',
  styleUrl: 'scriv-chat.css',
  shadow: false,
})
export class ScrivChat {
  @Prop() team!: string;
  @Prop() bot!: string;
  @Prop() buttonText: string = 'Chat';
  @Prop({ mutable: true }) visible: boolean = false;
  @Prop() scriv: string = SCRIV;
  @Prop() mode: 'inline' | 'widget' = 'inline'; // defaulting to inline for brevity

  @State() loaded: boolean = false;

  componentWillLoad() {
    this.loaded = this.visible;
    if (!Build.isDev) {
      this.scriv = SCRIV;
    }
  }

  private openChat() {
    this.visible = true;
    this.loaded = true;
  }

  private closeChat() {
    this.visible = false;
  }

  render() {
    console.log('Render => visible:', this.visible, 'mode:', this.mode);

    if (this.mode === 'inline') {
      return this.renderInlineMode();
    } else {
      return this.renderWidgetMode();
    }
  }

  /** 
   * 1) Inline Mode 
   *    - The user sees an input. 
   *    - Once clicked/focused, the overlay expanded chat appears 
   *      and covers everything behind it. 
   */
  private renderInlineMode() {
    return (
      <Host>
        <div class="inline-chat-container">
          {/*
            1) If NOT visible, we show a simple input field.
               Once the user clicks or focuses it, we expand (visible=true)
               so the user can interact with the real chat in the iframe.
          */}
          {!this.visible && (
            <div class="inline-input-bar">
              <input
                type="text"
                class="inline-chat-input"
                placeholder="Spørg vores AI-assistent..."
                onFocus={() => this.openChat()}
              />
            </div>
          )}

          {/*
            2) If visible, we show the expanded area containing the real iframe chat.
               The user can close it, returning to the collapsed input.
          */}
          {this.visible && (
            <div class="inline-chat-expanded">
              <button class="inline-close-btn" onClick={() => this.closeChat()}>
                Close
              </button>

              {this.loaded && (
                <iframe
                  class="inline-iframe"
                  src={`${this.scriv}/a/${this.team}/bots/b/${this.bot}/chat/`}
                ></iframe>
              )}

              <p class="inline-powered">
                ⚡ Powered by <a href="https://swishify.ai">Swishify.ai</a>
              </p>
            </div>
          )}
        </div>
      </Host>
    );
  }

  /** 2) Widget Mode (unchanged example) */
  private renderWidgetMode() {
    return (
      <Host>
        {!this.visible && (
          <button
            class="btn widget-button"
            onClick={() => this.openChat()}
          >
            {this.buttonText}
          </button>
        )}
        {this.visible && (
          <div class="widget-chat-window">
            <button
              class="widget-close-btn"
              onClick={() => this.closeChat()}
            >
              ✕
            </button>
            {this.loaded && (
              <iframe
                class="widget-iframe"
                src={`${this.scriv}/a/${this.team}/bots/b/${this.bot}/chat/`}
              ></iframe>
            )}
            <p class="widget-powered">
              ⚡ Powered by <a href="https://swishify.ai">Swishify.ai</a>
            </p>
          </div>
        )}
      </Host>
    );
  }
}
